import { _detect_graphlevel, _is_bomlevel_valid, _merge_bomlevel_on_graphlevel } from "./frfr-bomlevel-utils";
import { _virbom_validator_quick_incomplete } from "./frfr-virbom-manipulator-utils";


/*
FrFr FRIENDLY FRAMEWORK
frfr-smartbom-utils
Version ID: 1a 2024-05-31r1
by 
// Please describe here if you customized this file
*/


/*
NAJVAZNIJA SUSTINA koncepta smatrela je da se smartel_arr sastoji od local_virboma tacnije draftela koji proizvode local_virbome...


- output draftela definitivno ne treba da bude deo draftela ali je verovatno pametno da oba budu zapakovana u zajednicki objekat.

- smartel_arr se sastoji od smartela a svaki smartel u sebi moze da ima opet dva smartel_arr-a  usebi. jedan je self_smartel_arr koji je na istom nivou kao sam smartel a 

Takodje ima self_sekciju
- self sekcija moze biti prazna ili u njoj moze da bude jedan ili vise draftela
??? DA LI DA BUDE 

- draftel_container se sastoji od /////

- smartel draftel i prvi outputovani tj. root virtel u virbom_seq imaju isti subkey
ali nemaju isti parent_subkey. ???
Zato što virbom_seq ???

- graphlevel bi se dobijao pri kreiranju od parenta. ////


REDOSLED RENDEROVANJA SMARTELA
- svi virteli unutar smartela su unapred renderovani pri kreiranju ili izmeni draftela.
- tokom renderovanja se vrsi samo spajanje tj. merge-ovanje tih virbom-a u jedan globalni konaci.
- prvo se renderuje prvi smartel tj. njegov self_smartel_arr.
pošto je self_smartel_arr takodje array kroz njega se prolazi forEach petljom-
- zatim se sa forEcah petljoom prolazi kroz njegove childrene tj. njegov  children_smartel_arr

- PROBLEMATIKA kako sortirati draftele koji su unutar children_smartel_arr? Konkretno potrebno je da draftele koje dodamo kao children od modula uvek budu sortirani konzistentnim redosledom bez obzira kojim redom ih dodajemo ili brisemo?




*/


// DILEMA da li da smartel sadrzi kao self samo jedan draftel ili da ipak postoji self_smartel_arr ???



// smartel types
export const SMARTBOM = 'SMARTBOM';
const SMARTEL = 'SMARTEL';
const DRAFTEL = 'DRAFTEL';
const DRAFTEL_ARR = 'DRAFTEL_ARR';
const VIRBOM = 'VIRBOM';


//
const _smartbom_default_entity_make = (manifest, smartbom_cparams_own = null) => {
  let cparams_own = null; // TODO
  if (smartbom_cparams_own !== null && typeof smartbom_cparams_own === 'object' && !Array.isArray(smartbom_cparams_own)) { // if is object
    cparams_own = smartbom_cparams_own;
  }
  return {
    thisis: SMARTBOM,
    type: SMARTBOM, // smartel type
    smartbom_version: "2",
    enabled: true, // DA LI DA smartbom bude uvek enabled???
    parent_subkey: null, // ne postoji parent od samog smartboma
    subkey: null,
    graphlevel: 0, // smartbom ima nepostojeci graphlevel 0 jer je virtuelni iznad root grapohlevel 1.
    graphdepth: -1, // smartbom ima nepostojeći graphdepth -1 jer je virtuelan iznad root graphdepth 0.
    self: {
      // smartbom root container self
      manifest,
      draftel: null,
      virbom: null,
      cparams_own, // cascading params object
    },
    children_smartel_arr: [],
    stats: {},
  };
};


//
const _smartel_default_entity_make = () => {
  return {
    type: SMARTEL, // smartel type
    enabled: true,
    parent_subkey: null,
    subkey: null,
    graphlevel: null, // 
    smartel_calculated_graphlevel: null, // ovo zapravo treba da bude na nivou widgeta a sami smarteli ne moraju obavezno da znaju na kojem su levelu. U stvari vec znaju iz sopstvenog draftela.
    graphdepth: null,
    self: {
      draftel: null,
      virbom: null
    },
    // self_smartel_arr: [],
    children_smartel_arr: [],
    stats: {},
    /*
    draftel_container: {
      draftel: {},
      virbom: [], // draftel_output
    },
    */
  };
};


export const _smartbom_validator_quick_incomplete = (smartbom) => {
  // console.log('_smartbom_validator_quick_incomplete(smartbom)');
  if (smartbom && smartbom.type === SMARTBOM && smartbom.self && Array.isArray(smartbom.children_smartel_arr)) {
    return true; // valid
  } else {
    console.log('ERROR smartbom.type is not "SMARTBOM". Not valid smartbom object.');
    return false;
  }
};


//
export const _smartbom_manipulator_init_make_smartbom = (manifest, smartbom_cparams_own) => {
  return _smartbom_default_entity_make(manifest, smartbom_cparams_own);
};


//
export const _smartbom_utils_extract_cparams_own_from_smartel = (smartel) => {
  // smartel argument can be smartel or smartbom
  let cparams_own = null;
  // TODO
  if (smartel.self && smartel.self.cparams_own) {
    cparams_own = smartel.self.cparams_own;
  }
  return cparams_own;
};


//
export const _smartbom_manipulator_add_draftel = (smartbom, newDraftel, parent_subkey, _cb_sort, _cb_draftel_to_virbom) => {
  // dodaje u smartel_arr novi draftrel kao na priemr klimakomora, modul itd.
  //
  const smartel_arr = smartbom.children_smartel_arr;
  const updated_smartel_arr = _smartbom_traversing_utils_create_item(smartel_arr, newDraftel, parent_subkey, _cb_sort, _cb_draftel_to_virbom);
  //
  const finalized_smartbom = _smartel_bidirectionsl_traversing_enrich_with_stats(updated_smartel_arr, smartbom); // TEST
  return finalized_smartbom;
};


//
export const _smartbom_manipulator_delete_draftel = (smartbom, subkey) => {
  //
  const smartel_arr = smartbom.children_smartel_arr;
  const updated_smartel_arr = _smartbom_traversing_utils_delete_item(smartel_arr, subkey);
  //
  const finalized_smartbom = _smartel_bidirectionsl_traversing_enrich_with_stats(updated_smartel_arr, smartbom); // TEST
  return finalized_smartbom;
};


//
export const _smartbom_manipulator_update_draftel = (smartbom, subkey, editedDraftel, _cb_draftel_to_virbom) => {
  //
  // const entity = _smartbom_traversing_utils_get_item_by_subkey(smartel_arr, subkey); // ???
  // console.log('+++ get entity form tree', entity);
  let _editedDraftel = {
    ...editedDraftel,
    subkey
  };
  const smartel_arr = smartbom.children_smartel_arr;
  const editedEntityPack = { draftel: _editedDraftel };
  const updated_smartel_arr = _smartbom_traversing_utils_update_item(smartel_arr, editedEntityPack, subkey, _cb_draftel_to_virbom);
  //
  const finalized_smartbom = _smartel_bidirectionsl_traversing_enrich_with_stats(updated_smartel_arr, smartbom); // TEST
  return finalized_smartbom;
};


//
export const _smartbom_manipulator_upsert_self_property = (smartbom, subkey, keyVal, _cb_draftel_to_virbom) => {
  // UPSRET (update or insert)
  console.log('_smartbom_manipulator_upsert_self_property', subkey, keyVal);
  //
  const editedEntityPack = { key_val: keyVal };
  if (subkey === null) {
    // CASE smartbom root container element
    console.log('CASE smartbom root element');
    console.log('editedEntityPack', editedEntityPack);
    console.log('editedEntityPack.key_val', editedEntityPack.key_val);
    console.log('editedEntityPack.editedEntityPack.key_val.key', typeof editedEntityPack.key_val.key);
    let updated_self = smartbom.self;
    if (editedEntityPack.key_val && typeof editedEntityPack.key_val.key === 'string') {
      const key = editedEntityPack.key_val.key;
      const val = editedEntityPack.key_val.val;
      updated_self = {
        ...smartbom.self,
        [key]: val
      };
      if (editedEntityPack.key_val.key === 'cparams_own' && editedEntityPack.key_val.val === null) {
        // delete updated_self.cparams_own; // TODO
      }
    }
    const _finalized_smartbom = {
      ...smartbom,
      self: updated_self
    }
    return _finalized_smartbom;
  } else {
    // CASE regular smartel
    console.log('CASE regular smartel');
    const smartel_arr = smartbom.children_smartel_arr;
    const updated_smartel_arr = _smartbom_traversing_utils_update_item(smartel_arr, editedEntityPack, subkey, _cb_draftel_to_virbom);
    //
    const finalized_smartbom = _smartel_bidirectionsl_traversing_enrich_with_stats(updated_smartel_arr, smartbom); // TEST
    return finalized_smartbom;
  }
};


//
export const _smartbom_manipulator_update_refresh_all = (smartbom, _cb_draftel_to_virbom) => {
  //
  const smartel_arr = smartbom.children_smartel_arr;
  const updated_smartel_arr = _smartbom_traversing_utils_update_refresh_all(smartel_arr, _cb_draftel_to_virbom);
  //
  const finalized_smartbom = _smartel_bidirectionsl_traversing_enrich_with_stats(updated_smartel_arr, smartbom); // TEST
  return finalized_smartbom;
};


//
export const _smartbom_manipulator_update_draftel_enabled = (smartbom, subkey, enabled) => {
  //
  const smartel_arr = smartbom.children_smartel_arr;
  if (enabled === true) {
    // updated_smartel_entity.enabled = true;
    const updated_smartel_arr = _smartbom_traversing_utils_update_item_enabled(smartel_arr, enabled, subkey);
    //
    const finalized_smartbom = _smartel_bidirectionsl_traversing_enrich_with_stats(updated_smartel_arr); // TEST
    return finalized_smartbom;
  } else if (enabled === false) {
    // updated_smartel_entity.enabled = false;
    const updated_smartel_arr = _smartbom_traversing_utils_update_item_enabled(smartel_arr, enabled, subkey);
    //
    const finalized_smartbom = _smartel_bidirectionsl_traversing_enrich_with_stats(updated_smartel_arr, smartbom); // TEST
    return finalized_smartbom;
  } else {
    // no changes
    return smartbom;
  }
};


//
export const _smartbom_manipulator_get_draftel_single_by_subkey = (smartbom, subkey) => {
  let draftel = null;
  const smartel_arr = smartbom.children_smartel_arr;
  const smartel = _smartbom_traversing_utils_get_item_by_subkey(smartel_arr, subkey);
  if (smartel && smartel.self && smartel.self.draftel && smartel.self.draftel.subkey === subkey) {
    draftel = {
      ...smartel.self.draftel
    };
  }
  // 
  return draftel; //
};


//
export const _smartbom_manipulator_detect_last_subkey = (smartbom) => {
  const smartel_arr = smartbom.children_smartel_arr;
  const max = _smartbom_traversing_utils_detect_max_subkey(smartel_arr);
  // 
  return max; // max/last subkey
};


//
export const _smartbom_manipulator_count_top_graphlevel_smartels = (smartbom) => {
  let count = -1;
  if (_smartbom_validator_quick_incomplete(smartbom)) {
    const smartel_arr = smartbom.children_smartel_arr;
    count = smartel_arr.length;
  }
  // 
  return count;
};


//
export const _smartbom_manipulator_count_draftels_where_draftelschemakey = (smartbom, _draftelschemakey) => {
  const smartel_arr = smartbom.children_smartel_arr;
  const count = _smartbom_traversing_utils_count_draftels_where_draftelschemakey(smartel_arr, _draftelschemakey);
  // 
  return count;
};


//
export const _smartbom_manipulator_get_children_smartel_arr = (smartbom, parent_subkey) => {
  const smartel_arr = smartbom.children_smartel_arr;
  if (parent_subkey === null) {
    return smartel_arr; //
  } else {
    const _parent_smartel = _smartbom_traversing_utils_get_item_by_subkey(smartel_arr, parent_subkey);
    let children_smartel_arr = [];
    if (_parent_smartel && Array.isArray(_parent_smartel.children_smartel_arr)) {
      children_smartel_arr = [..._parent_smartel.children_smartel_arr];
    }
    // 
    return children_smartel_arr; //
  }
};




// ---------- SORTING
const _sort_smartel_arr_pure = (smartel_arr, _cb_sort) => {
  if (typeof _cb_sort === 'function') {
    const _sorted_smartel_arr = _cb_sort(smartel_arr);
    return [..._sorted_smartel_arr];
  } else {
    return smartel_arr;
  }
};




// ---------- TRAVERSING

//
const _smartbom_traversing_utils_get_item_by_subkey = (smartel_arr, subkey) => {
  // 
  let item = false;
  //
  // kada nije na root levelu nego ima parent
  const _tree_smartel_single = (smartel, this_graphlevel) => {
    ////
    if (smartel.subkey === subkey) {
      // ovo je taregt item
      item = {
        ...smartel
      }; // PURE clone
    } else {
      // trazimo medju njegovim childrenima
      let target_graphlevel = this_graphlevel + 1;
      _tree_smartel_each(smartel.children_smartel_arr, target_graphlevel);
    }
  }; // end of _dirty_tree_smartel_single
  //
  const _tree_smartel_each = (smartel_arr, target_graphlevel) => {
    smartel_arr.forEach((smartel) => {
      _tree_smartel_single(smartel, target_graphlevel);
    });
  }; //
  // START TRAVERSING
  _tree_smartel_each(smartel_arr, 1); // start from root level 1
  //
  return item; // PURE
};


//
const _smartbom_traversing_utils_detect_max_subkey = (smartel_arr) => {
  // 
  let max = 0;
  const _cb = (subkey) => {
    if (subkey > max) {
      max = subkey;
    }
  }
  //
  // kada nije na root levelu nego ima parent
  const _tree_smartel_single = (smartel, this_graphlevel) => {
    ////
    // self subkey
    _cb(smartel.subkey);
    // self.draftel.subkey
    if (smartel.self.draftel && smartel.self.draftel.subkey) {
      _cb(smartel.self.draftel.subkey);
    }
    // self.virbom each subkey
    if (smartel.self.virbom && _virbom_validator_quick_incomplete(smartel.self.virbom)) {
      let vmax = 0;
      smartel.self.virbom.forEach(item => {
        if (item && item.subkey > vmax) {
          vmax = item.subkey;
        }
      });
      _cb(vmax);
    }
    // trazimo medju njegovim childrenima
    let target_graphlevel = this_graphlevel + 1;
    _tree_smartel_each(smartel.children_smartel_arr, target_graphlevel);
  }; // end of _dirty_tree_smartel_single
  //
  const _tree_smartel_each = (smartel_arr, target_graphlevel) => {
    smartel_arr.forEach((smartel) => {
      _tree_smartel_single(smartel, target_graphlevel);
    });
  }; //
  // START TRAVERSING
  _tree_smartel_each(smartel_arr, 1); // start from root level 1
  //
  return max; // detected max subkey in whole smartbom
};


//
const _smartbom_traversing_utils_count_draftels_where_draftelschemakey = (smartel_arr, _draftelschemakey) => {
  // 
  let count = 0;
  const _cb = () => {
    count++;
  }
  //
  // kada nije na root levelu nego ima parent
  const _tree_smartel_single = (smartel, this_graphlevel) => {
    ////
    // self.draftel
    if (smartel.self.draftel && smartel.self.draftel._draftelschemakey) {
      if (smartel.self.draftel._draftelschemakey === _draftelschemakey) {
        _cb();
      }
    }
    // trazimo medju njegovim childrenima
    let target_graphlevel = this_graphlevel + 1;
    _tree_smartel_each(smartel.children_smartel_arr, target_graphlevel);
  }; // end of _dirty_tree_smartel_single
  //
  const _tree_smartel_each = (smartel_arr, target_graphlevel) => {
    smartel_arr.forEach((smartel) => {
      _tree_smartel_single(smartel, target_graphlevel);
    });
  }; //
  // START TRAVERSING
  _tree_smartel_each(smartel_arr, 1); // start from root level 1
  //
  return count; //
};


//
const _smartbom_traversing_utils_create_item = (smartel_arr, newDraftel, parent_subkey, _cb_sort, _cb_draftel_to_virbom) => {
  // dopunjava smartel_arr sa statistickim podacima i levelima
  let updated_smartel_arr = [];
  console.log('_smartbom_traversing_utils_create_item');
  console.log('+++++', parent_subkey, 'newDraftel.parent_subkey', newDraftel.parent_subkey);
  //
  const new_smartel = {
    ..._smartel_default_entity_make(),
    readme: 'SMARTEL',
    _draftelschemakey: newDraftel._draftelschemakey,
    subkey: newDraftel.subkey,
    parent_subkey: newDraftel.parent_subkey,
    graphlevel: null,
    graphdepth: null,
    self: {
      draftel: {
        ...newDraftel
      },
      virbom: _cb_draftel_to_virbom(newDraftel)
    },
    children_smartel_arr: [],
  };
  console.log('+++ new smartel just created but not final');
  //
  if (parent_subkey === null) {
    // kada je na root level 1 (nema parent)
    new_smartel.graphlevel = 1; // root level 1
    new_smartel.graphdepth = new_smartel.graphlevel - 1; // root depth 0
    updated_smartel_arr = _sort_smartel_arr_pure([...smartel_arr, new_smartel], _cb_sort);
  } else {
    // kada nije na root levelu nego ima parent
    const _tree_smartel_single = (smartel, this_graphlevel) => {
      ////
      const _graphlevel_for_nesting_child_smartel = this_graphlevel + 1;
      console.log('***** _graphlevel_for_nesting_child_smartel', _graphlevel_for_nesting_child_smartel);
      if (smartel.subkey === parent_subkey) {
        // ovo je njegov parent
        // vrsimo update. dodajemo newDraftel kao njegov children dirty
        new_smartel.graphlevel = _graphlevel_for_nesting_child_smartel; // ???
        new_smartel.graphdepth = new_smartel.graphlevel - 1;
        const updated_children_smartel_arr = _sort_smartel_arr_pure([...smartel.children_smartel_arr, new_smartel], _cb_sort);
        // dirty update smartel
        smartel.children_smartel_arr = updated_children_smartel_arr;
        console.log('smartel AFTER UPDATE children with new created item', smartel);
      } else {
        // trazimo medju njegovim childrenima
        let target_graphlevel = this_graphlevel + 1;
        _tree_smartel_each(smartel.children_smartel_arr, target_graphlevel);
      }
    }; // end of _dirty_tree_smartel_single
    //
    const _tree_smartel_each = (smartel_arr, target_graphlevel) => {
      console.log('target_graphlevel', target_graphlevel);
      smartel_arr.forEach((smartel) => {
        /*
        if (smartel.graphlevel === target_graphlevel) {
          _tree_smartel_single(smartel, target_graphlevel);
        }
        */
        _tree_smartel_single(smartel, target_graphlevel);
      });
    }; //
    // START TRAVERSING
    _tree_smartel_each(smartel_arr, 1); // start from root level 1
    updated_smartel_arr = _sort_smartel_arr_pure([...smartel_arr], _cb_sort);
  }
  // return updated_smartel_arr;
  return [...updated_smartel_arr]; // PURE
};


//
const _smartbom_traversing_utils_update_item = (smartel_arr, editedEntityPack, subkey, _cb_draftel_to_virbom) => {
  //
  console.log('editedEntityPack', editedEntityPack);
  //
  const _tree_smartel_single = (smartel, this_graphlevel) => {
    let returning_smartel;
    if (smartel.subkey === subkey) {
      // target item
      let updated_self = smartel.self;
      if (editedEntityPack.draftel) {
        const editedDraftel = editedEntityPack.draftel;
        updated_self = {
          ...smartel.self,
          draftel: {
            ...editedDraftel,
            subkey
          },
          virbom: _cb_draftel_to_virbom(editedDraftel)
        };
      }
      if (editedEntityPack.key_val && typeof editedEntityPack.key_val.key === 'string') {
        const key = editedEntityPack.key_val.key;
        const val = editedEntityPack.key_val.val;
        updated_self = {
          ...smartel.self,
          [key]: val
        };
        if (editedEntityPack.key_val.key === 'cparams_own' && editedEntityPack.key_val.val === null) {
          delete updated_self.cparams_own;
        }
      }
      const updated_smartel = {
        ...smartel,
        /*
        self: {
          draftel: {
            ...editedDraftel,
            subkey
          },
          virbom: _cb_draftel_to_virbom(editedDraftel)
        },
        */
        self: updated_self
      };
      // vrsimo update samog itema dirty
      returning_smartel = {
        ...updated_smartel
      }; // dirty smartel mutate
      console.log('returning_smartel AFTER UPDATE DIRTY', returning_smartel);
    } else {
      // smartel ostaje neizmenjen
      returning_smartel = smartel;
    }
    // pre ili nakon selfa UVEK moramo IZNOVA pushovati i sve childrene
    const target_graphlevel = this_graphlevel + 1;
    returning_smartel.children_smartel_arr = _tree_smartel_each(smartel.children_smartel_arr, target_graphlevel);
    return returning_smartel;
  }; // end of _dirty_tree_smartel_single
  //
  const _tree_smartel_each = (smartel_arr, target_graphlevel) => {
    let _transformed_smartel_arr = [];
    smartel_arr.forEach((smartel) => {
      // *MAP
      _transformed_smartel_arr.push(_tree_smartel_single(smartel, target_graphlevel))
    });
    return _transformed_smartel_arr;
  }; //
  // START TRAVERSING
  const transformed_smartel_arr = _tree_smartel_each(smartel_arr, 1); // start from root level 1
  //
  // return updated_smartel_arr;
  console.log('AFTER TREE UPDATE updated_smartel_arr', transformed_smartel_arr);
  return [...transformed_smartel_arr]; // PURE
};


//
const _smartbom_traversing_utils_update_item_enabled = (smartel_arr, enabled, subkey) => {
  //
  console.log('_smartbom_traversing_utils_update_item_enabled - enabled', enabled);
  //
  const _tree_smartel_single = (smartel, this_graphlevel) => {
    let returning_smartel;
    if (smartel.subkey === subkey) {
      // target item
      const updated_smartel = {
        ...smartel,
        enabled
      };
      // vrsimo update samog itema dirty
      returning_smartel = {
        ...updated_smartel
      }; // dirty smartel mutate
      console.log('returning_smartel AFTER UPDATE DIRTY', returning_smartel);
    } else {
      // smartel ostaje neizmenjen
      returning_smartel = smartel;
    }
    // pre ili nakon selfa UVEK moramo IZNOVA pushovati i sve childrene
    const target_graphlevel = this_graphlevel + 1;
    returning_smartel.children_smartel_arr = _tree_smartel_each(smartel.children_smartel_arr, target_graphlevel);
    return returning_smartel;
  }; // end of _dirty_tree_smartel_single
  //
  const _tree_smartel_each = (smartel_arr, target_graphlevel) => {
    let _transformed_smartel_arr = [];
    smartel_arr.forEach((smartel) => {
      // *MAP
      _transformed_smartel_arr.push(_tree_smartel_single(smartel, target_graphlevel))
    });
    return _transformed_smartel_arr;
  }; //
  // START TRAVERSING
  const transformed_smartel_arr = _tree_smartel_each(smartel_arr, 1); // start from root level 1
  //
  // return updated_smartel_arr;
  console.log('AFTER TREE UPDATE updated_smartel_arr', transformed_smartel_arr);
  return [...transformed_smartel_arr]; // PURE
};


//
const _smartbom_traversing_utils_delete_item = (smartel_arr, subkey) => {
  //
  console.log('_smartbom_traversing_utils_delete_item - subkey', subkey);
  //
  const _tree_smartel_single = (smartel, this_graphlevel) => {
    let returning_smartel;
    if (smartel.subkey === subkey) {
      // target item
      returning_smartel = false;
      console.log('deleting smartel subkey', subkey, 'returning_smartel', returning_smartel);
      return false; // DELETING
    } else {
      // smartel ostaje neizmenjen
      returning_smartel = smartel;
    }
    // pre ili nakon selfa UVEK moramo IZNOVA pushovati i sve childrene
    const target_graphlevel = this_graphlevel + 1;
    returning_smartel.children_smartel_arr = _tree_smartel_each(smartel.children_smartel_arr, target_graphlevel);
    return returning_smartel;
  }; // end of _dirty_tree_smartel_single
  //
  const _tree_smartel_each = (smartel_arr, target_graphlevel) => {
    let _transformed_smartel_arr = [];
    smartel_arr.forEach((smartel) => {
      const returning_smartel = _tree_smartel_single(smartel, target_graphlevel);
      // *FILTER
      if (returning_smartel === false) {
        // if return false then smartel will be excluded
        // skip adding this one
      } else {
        // all others stay in array
        _transformed_smartel_arr.push(returning_smartel)
      }
    });
    return _transformed_smartel_arr;
  }; //
  // START TRAVERSING
  const transformed_smartel_arr = _tree_smartel_each(smartel_arr, 1); // start from root level 1
  //
  // return updated_smartel_arr;
  console.log('AFTER TREE UPDATE updated_smartel_arr', transformed_smartel_arr);
  return [...transformed_smartel_arr]; // PURE
};


//
const _smartbom_traversing_utils_update_refresh_all = (smartel_arr, _cb_draftel_to_virbom) => {
  //
  console.log('_smartbom_traversing_utils_update_refresh_all');
  //
  const _tree_smartel_single = (smartel, this_graphlevel) => {
    let returning_smartel;
    if (true) { // svaki item je target item jer refreshujemo sve
      // target item
      const updated_smartel = {
        ...smartel,
        self: {
          ...smartel.self,
          virbom: _cb_draftel_to_virbom(smartel.self.draftel) // od istog draftela se ponovo izracunava virbom
        }
      };
      // vrsimo update samog itema dirty
      returning_smartel = {
        ...updated_smartel
      }; // dirty smartel mutate
      // console.log('returning_smartel AFTER UPDATE DIRTY', returning_smartel);
    } else {
      // smartel ostaje neizmenjen
      // returning_smartel = smartel;
    }
    // pre ili nakon selfa UVEK moramo IZNOVA pushovati i sve childrene
    const target_graphlevel = this_graphlevel + 1;
    returning_smartel.children_smartel_arr = _tree_smartel_each(smartel.children_smartel_arr, target_graphlevel);
    return returning_smartel;
  }; // end of _dirty_tree_smartel_single
  //
  const _tree_smartel_each = (smartel_arr, target_graphlevel) => {
    let _transformed_smartel_arr = [];
    smartel_arr.forEach((smartel) => {
      // *MAP
      _transformed_smartel_arr.push(_tree_smartel_single(smartel, target_graphlevel))
    });
    return _transformed_smartel_arr;
  }; //
  // START TRAVERSING
  const transformed_smartel_arr = _tree_smartel_each(smartel_arr, 1); // start from root level 1
  //
  // return updated_smartel_arr;
  console.log('AFTER TREE UPDATE updated_smartel_arr', transformed_smartel_arr);
  return [...transformed_smartel_arr]; // PURE
};



// -----
// 
const _calculate_stats_for_smartbom = (smartel_arr) => {
  const stats = {
    count_draftel_enabled: 0,
    count_draftel_disabled: 0,
    count_draftel_total: 0,
    count_virtel_enabled: 0,
    count_virtel_disabled: 0,
    count_virtel_total: 0,
  };
  if (Array.isArray(smartel_arr)) {
    smartel_arr.forEach((smartel) => {
      // root level smartel
      stats.count_draftel_enabled += smartel.stats.count_draftel_enabled;
      stats.count_draftel_disabled += smartel.stats.count_draftel_disabled;
      stats.count_draftel_total += smartel.stats.count_draftel_total;
      stats.count_virtel_enabled += smartel.stats.count_virtel_enabled;
      stats.count_virtel_disabled += smartel.stats.count_virtel_disabled;
      stats.count_virtel_total += smartel.stats.count_virtel_total;
    });
  }
  return stats;
};
//
const _make_new_obj_children_collected_data = () => {
  const children_collected_data = {
    count_draftel_enabled: 0,
    count_draftel_disabled: 0,
    count_virtel_enabled: 0,
    count_virtel_disabled: 0,
    count_virtel_self_enabled: 0,
    count_virtel_self_disabled: 0,
  };
  return children_collected_data;
};
//
const _combine_own_and_children_collected_data = (own_data, children_collected_data, inside_disabled) => {
  // console.log('* children_collected_data');
  // console.log(children_collected_data);
  const combined_data = {
    count_draftel_self_enabled: 0,
    count_draftel_self_disabled: 0,
    count_draftel_self_total: 0,
    count_draftel_children_enabled: 0,
    count_draftel_children_disabled: 0,
    count_draftel_children_total: 0,
    count_draftel_enabled: 0,
    count_draftel_disabled: 0,
    count_draftel_total: 0,
    //
    count_virtel_self_enabled: 0,
    count_virtel_self_disabled: 0,
    count_virtel_self_total: 0,
    count_virtel_children_enabled: 0,
    count_virtel_children_disabled: 0,
    count_virtel_children_total: 0,
    count_virtel_enabled: 0,
    count_virtel_disabled: 0,
    count_virtel_total: 0,
    //
    _is_disabled: false,
    _prev_bomlevel: false,
  };
  combined_data.count_draftel_self_enabled = own_data.count_draftel_self_enabled; // own self
  combined_data.count_draftel_self_disabled = own_data.count_draftel_self_disabled; // own self
  combined_data.count_draftel_self_total = combined_data.count_draftel_self_enabled + combined_data.count_draftel_self_disabled;
  combined_data.count_draftel_children_enabled = children_collected_data.count_draftel_enabled; // children
  combined_data.count_draftel_children_disabled = children_collected_data.count_draftel_disabled;// children
  combined_data.count_draftel_children_total = combined_data.count_draftel_children_enabled + combined_data.count_draftel_children_disabled;
  combined_data.count_draftel_enabled = own_data.count_draftel_enabled + children_collected_data.count_draftel_enabled; // self+children
  combined_data.count_draftel_disabled = own_data.count_draftel_disabled + children_collected_data.count_draftel_disabled; // self+children
  combined_data.count_draftel_total = combined_data.count_draftel_enabled + combined_data.count_draftel_disabled;
  //
  combined_data.count_virtel_self_enabled = own_data.count_virtel_self_enabled; // own self
  combined_data.count_virtel_self_disabled = own_data.count_virtel_self_disabled; // own self
  combined_data.count_virtel_self_total = combined_data.count_virtel_self_enabled + combined_data.count_virtel_self_disabled;
  combined_data.count_virtel_children_enabled = children_collected_data.count_virtel_enabled; // children
  combined_data.count_virtel_children_disabled = children_collected_data.count_virtel_disabled; // children
  combined_data.count_virtel_children_total = combined_data.count_virtel_children_enabled + combined_data.count_virtel_children_disabled;
  combined_data.count_virtel_enabled = own_data.count_virtel_enabled + children_collected_data.count_virtel_enabled; // self+children
  combined_data.count_virtel_disabled = own_data.count_virtel_disabled + children_collected_data.count_virtel_disabled; // self+children
  combined_data.count_virtel_total = combined_data.count_virtel_enabled + combined_data.count_virtel_disabled;
  if (inside_disabled === false) {
    // inside enabled
  } else {
    // // CASE DISABLED inside disabled count enabled also as disabled
    combined_data.count_draftel_self_enabled = 0;
    combined_data.count_draftel_self_disabled = combined_data.count_draftel_self_total;
    combined_data.count_draftel_children_enabled = 0;
    combined_data.count_draftel_children_disabled = combined_data.count_draftel_children_total;
    combined_data.count_draftel_enabled = 0;
    combined_data.count_draftel_disabled = combined_data.count_draftel_total;
    combined_data.count_virtel_self_enabled = 0;
    combined_data.count_virtel_self_disabled = combined_data.count_virtel_self_total;
    combined_data.count_virtel_children_enabled = 0;
    combined_data.count_virtel_children_disabled = combined_data.count_virtel_children_total;
    combined_data.count_virtel_enabled = 0;
    combined_data.count_virtel_disabled = combined_data.count_virtel_total;
  }
  combined_data._prev_bomlevel = own_data._prev_bomlevel;
  combined_data._is_disabled = own_data._is_disabled;
  return combined_data;
};
//
const _collector = (child_data, ref_children_collected_data) => {
  // every child will merge self data with their sibling data
  // ref_children_collected_data.vreme_kumulativno += child_data.vreme_kumulativno;
  ref_children_collected_data.count_draftel_enabled += child_data.count_draftel_enabled;
  ref_children_collected_data.count_draftel_disabled += child_data.count_draftel_disabled;
  ref_children_collected_data.count_virtel_enabled += child_data.count_virtel_enabled;
  ref_children_collected_data.count_virtel_disabled += child_data.count_virtel_disabled;
  return ref_children_collected_data;
};
//
const _smartel_bidirectionsl_traversing_enrich_with_stats = (smartel_arr, smartbom) => {
  // const smartel_arr = smartbom.children_smartel_arr; // kasnije ce tek biti spakovani u smartbom na kraju ove funkcije
  console.log('_smartel_bidirectionsl_traversing_enrich_with_stats(smartel_arr) UPDATE STATS', smartel_arr);
  //
  const _dirty_global_bomlevel_arr = [];
  const _dirty_global_bomlevel_get_prev_bomlevel = () => {
    if (_dirty_global_bomlevel_arr.length > 0) {
      const _last_final_bomlevel = _dirty_global_bomlevel_arr[_dirty_global_bomlevel_arr.length - 1];
      return _last_final_bomlevel;
    }
    return false;
  };
  const _dirty_global_bomlevel_add = (graphlevel, bomlevel) => {
    // console.log('_dirty_global_bomlevel_add(graphlevel, bomlevel)', graphlevel, bomlevel);
    if (_is_bomlevel_valid(bomlevel)) {
      if (_dirty_global_bomlevel_arr.length > 0) {
        // CASE add more
        const _last_final_bomlevel = _dirty_global_bomlevel_arr[_dirty_global_bomlevel_arr.length - 1];
        const new_final_bomlevel = _merge_bomlevel_on_graphlevel(_last_final_bomlevel, bomlevel, graphlevel);
        _dirty_global_bomlevel_arr.push(new_final_bomlevel);
      } else {
        // CASE add first bomlevel
        const new_final_bomlevel = bomlevel;
        _dirty_global_bomlevel_arr.push(new_final_bomlevel);
      }
    }
  };
  //
  const _tree_smartel_single = (smartel, this_graphlevel, _cb_for_me, ref_sibling_collected_data, parent_disabled) => {

    // -----NORMAL TRAVERSING DIRECTION----- od parent prema children

    // KORAK OWN
    let is_disabled = false;
    if (parent_disabled === true || smartel.enabled === false) {
      // parent_disabled ima prioritet! Bez obzira sto je smartel enabled ako se nalazi unutar parent_disabled on je is_disabled i ne moze se više ponašati kao da je enabled.
      is_disabled = true;
    }
    console.log('parent_disabled', parent_disabled, 'is_disabled', is_disabled);
    const own_data = {
      count_draftel_enabled: 0,
      count_draftel_disabled: 0,
      count_draftel_self_enabled: 0,
      count_draftel_self_disabled: 0,
      count_virtel_enabled: 0,
      count_virtel_disabled: 0,
      count_virtel_self_enabled: 0,
      count_virtel_self_disabled: 0,
      _is_disabled: is_disabled,
      _prev_bomlevel: false,
    };
    //
    if (smartel.self.draftel && smartel.self.draftel._draftelschemakey) {
      // draftel postoji i brojimo kao 1 draftel
      own_data.count_draftel_self_enabled = 1; //
      if (is_disabled === false) {
        own_data.count_draftel_self_enabled = 1;
        own_data.count_draftel_self_disabled = 0;
        own_data.count_draftel_enabled = own_data.count_draftel_self_enabled;
        own_data.count_draftel_disabled = own_data.count_draftel_self_disabled;
      } else {
        // CASE DISABLED
        own_data.count_draftel_self_enabled = 0;
        own_data.count_draftel_self_disabled = 1;
        own_data.count_draftel_enabled = own_data.count_draftel_self_enabled;
        own_data.count_draftel_disabled = own_data.count_draftel_self_disabled;
      }
    }
    if (Array.isArray(smartel.self.virbom)) {
      if (is_disabled === false) {
        own_data.count_virtel_self_enabled = smartel.self.virbom.length;
        own_data.count_virtel_self_disabled = 0;
        own_data.count_virtel_enabled = own_data.count_virtel_self_enabled;
        own_data.count_virtel_disabled = own_data.count_virtel_self_disabled;
        //
        if (smartel.self.virbom.length > 0) {
          own_data._prev_bomlevel = _dirty_global_bomlevel_get_prev_bomlevel();
          const _last_self_virtel = smartel.self.virbom[smartel.self.virbom.length - 1];
          _dirty_global_bomlevel_add(this_graphlevel, _last_self_virtel.bomlevel);
        }
        //
      } else {
        // CASE DISABLED
        own_data.count_virtel_self_enabled = 0;
        own_data.count_virtel_self_disabled = smartel.self.virbom.length;
        own_data.count_virtel_enabled = own_data.count_virtel_self_enabled;
        own_data.count_virtel_disabled = own_data.count_virtel_self_disabled;
      }
    }

    // KORAK pred spustanje na children nivo
    const ref_children_collected_data = _make_new_obj_children_collected_data(); // new object

    const _cb_for_children = (child_data, ref_children_collected_data) => {
      // DIRTY UPDATE ref_children_collected_data
      _collector(child_data, ref_children_collected_data); // every child will merge self data with their sibling data
    };

    // KORAK CHILDREN - pozivanje iteracija za children elemente
    const target_graphlevel = this_graphlevel + 1;
    const children_smartel_arr = _tree_smartel_each(smartel.children_smartel_arr, target_graphlevel, _cb_for_children, ref_children_collected_data, is_disabled);
    _combine_own_and_children_collected_data(own_data, ref_children_collected_data);
    //


    // -----REVERSE TRAVERSING DIRECTION-----
    // REVERSE ZNACI U SMERU OD CHILDREN PREMA PARENTU


    // KORAK COMBINE OWN AND CHILDREN DATA
    const combined_data = _combine_own_and_children_collected_data(own_data, ref_children_collected_data, is_disabled);

    // --- KORAK SLANJE PODATAKA PARENTU
    if (typeof _cb_for_me === 'function' && ref_sibling_collected_data) {
      // na ovaj callback saljemo parent-u vreme kumulativno i vreme_ugradnje_u_parent
      _cb_for_me(combined_data, ref_sibling_collected_data);
    } else {
      // graphlevel 1 - prvi nivo zovemo bez callbacka
      // sta se tada desava??? verovatno ne treba nista za graphlevel 1 jer on nema parent i nema kome da salje svoju vrednost.
    }

    // KORAK UPDATE VIRTEL
    // console.log('+*+*+*+*+*+* children_smartel_arr', children_smartel_arr);
    const returning_smartel = {
      // enriched smartel
      ...smartel,
      children_smartel_arr: children_smartel_arr,
      stats: {
        ...combined_data
      }
    };
    // return returning_smartel;
    // console.log('returning_smartel', returning_smartel);
    return returning_smartel;
  }; // end of _dirty_tree_smartel_single
  //
  const _tree_smartel_each = (smartel_arr, target_graphlevel, _cb, ref_children_collected_data, parent_disabled) => {
    // console.log('foreach smartel_arr', smartel_arr);
    let _transformed_smartel_arr = [];
    smartel_arr.forEach((smartel) => {
      // *MAP_tree_smartel_each      // console.log('foreach smartel', typeof smartel.children_smartel_arr, smartel);
      const _returning_smartel = _tree_smartel_single(smartel, target_graphlevel, _cb, ref_children_collected_data, parent_disabled);
      _transformed_smartel_arr.push(_returning_smartel);
    });
    // console.log('_transformed_smartel_arr. LENGTH', _transformed_smartel_arr.length);
    // return [_transformed_smartel_arr, cc];
    return _transformed_smartel_arr;
  }; // end of _tree_smartel_each
  //
  //
  // START TRAVERSING
  // const transformed_smartel_arr = _tree_smartel_each(smartel_arr, 1, false); // start from root level 1
  const transformed_smartel_arr = _tree_smartel_each(smartel_arr, 1, null, null, null); // start from root level 1
  //
  // return [...transformed_smartel_arr]; // PURE
  const smartel_container_stats = _calculate_stats_for_smartbom(transformed_smartel_arr);
  const finalized_smartbom = {
    // ..._smartbom_default_entity_make(),
    ...smartbom,
    children_smartel_arr: [...transformed_smartel_arr], // PURE
    stats: { ...smartel_container_stats },
    readme: 'Updated stats for whole smartel_arr'
  };
  console.log('AFTER COUNTING updated_smartbom', finalized_smartbom);
  console.log('_dirty_global_bomlevel_arr', _dirty_global_bomlevel_arr);
  return finalized_smartbom; // PURE
};


//
// Self-Executing Anonymous Function - IIFE (Immediately Invoked Function Expression).

